import { render, staticRenderFns } from "./ShopCartBtn.vue?vue&type=template&id=247a1d62&scoped=true&"
import script from "./ShopCartBtn.vue?vue&type=script&lang=js&"
export * from "./ShopCartBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247a1d62",
  null
  
)

export default component.exports